import { buildCoreFields } from "./trainingFormFieldsCore";
import { buildProviderFields } from "./trainingFormFieldsProvider";
import { buildValidityFields } from "./trainingFormFieldsValidity";

/**
 * Builds the complete array of field descriptors passed to `renderDynamicallyFields`
 * in the Training form modal. Delegates to three focused sub-builders:
 * - `buildCoreFields` — identity, classification, and branch scope fields
 * - `buildValidityFields` — validity type and conditional numeric/date fields
 * - `buildProviderFields` — provider type, external provider, responsible person, and metadata
 *
 * @param {object} params
 * @param {object} params.data - Modal data (training record or empty object for new).
 * @param {Function} params.t - i18next translation function.
 * @param {import("rc-field-form").FormInstance} params.form - Ant Design form instance.
 * @param {boolean} params.isNewRecord - Whether we are creating a new training.
 * @param {boolean} params.branchesVisible - Open state of the branch dropdown.
 * @param {Function} params.setBranchesVisible - Setter for branchesVisible.
 * @param {string|undefined} params.validity - Currently selected validity type.
 * @param {Function} params.setValidity - Setter for validity.
 * @param {string|undefined} params.language - Currently selected primary language.
 * @param {Function} params.setLanguage - Setter for language.
 * @param {number|undefined} params.linkedTraining - Currently selected linked training id.
 * @param {Function} params.setLinkedTraining - Setter for linkedTraining.
 * @param {number|undefined} params.internalProvider - Provider type (1 = internal, 0 = external).
 * @param {Function} params.setInternalProvider - Setter for internalProvider.
 * @returns {Array} Field descriptor objects consumed by `renderDynamicallyFields`.
 */
const buildTrainingFormFields = (params) => [
  ...buildCoreFields(params),
  ...buildValidityFields(params),
  ...buildProviderFields(params)
];

export { buildTrainingFormFields };
